import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultFlpOverviewPageTwoData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'flp-overview-page-two-list',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'flp-overview-page-two-heading',
              type: 'EducationalSlideHeading',
              props: {
                title: 'Is an FLP right for me?',
                variant: 'h3',
              },
            },
            {
              id: 'flp-overview-page-two-estate-size',
              type: 'PresentationListItem',
              props: {
                title: 'Estate size',
                description:
                  'If your estate exceeds or is approaching the federal estate and gift tax exemption limit, an FLP can help move future asset appreciation out of your taxable estate.',
                iconType: 'lightbulb',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'flp-overview-page-two-asset-fit',
              type: 'PresentationListItem',
              props: {
                title: 'Asset fit',
                description:
                  'An FLP works best when your assets — business interests, real estate, or investments — are ones you’re willing to hold inside a partnership for the long term.',
                iconType: 'lightbulb',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'flp-overview-page-two-ongoing-involvement',
              type: 'PresentationListItem',
              props: {
                title: 'Ongoing involvement',
                description:
                  'An FLP requires an active General Partner. You should be comfortable staying involved to manage the entity and oversee investment and distribution decisions.',
                iconType: 'lightbulb',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'flp-overview-page-two-professional-guidance',
              type: 'PresentationListItem',
              props: {
                title: 'Professional guidance',
                description:
                  'Consulting with estate planning professionals, including attorneys and financial advisors, is essential to evaluate whether an FLP aligns with your overall financial strategy.',
                iconType: 'lightbulb',
                iconColor: 'PRIMARY',
              },
            },
          ],
        },
      },
    ],
  };
}
